// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as PartnerScoreAssetConfig from "../../assets/PartnerScoreAssetConfig.bs.js";

function SuspensionGuideHeaderCmp(Props) {
  var title_text = Props.title_text;
  var index = Props.index;
  var accordionOnClick = Props.accordionOnClick;
  return React.createElement("div", {
              className: "suspension-guide-header-container",
              onClick: (function (param) {
                  return Curry._1(accordionOnClick, index - 1 | 0);
                })
            }, React.createElement("h3", {
                  className: "suspension-guide-header"
                }, title_text), React.createElement("img", {
                  className: "suspension-guide-dropdown-icon",
                  src: PartnerScoreAssetConfig.dropdown_icon
                }));
}

var make = SuspensionGuideHeaderCmp;

export {
  make ,
  
}
/* react Not a pure module */
